import { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";




const baseURL = `${process.env.REACT_APP_API_URL}`

export default function useProfileData() {
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const { id } = useParams();
    const [error, setError] = useState('');

    useEffect(() => {
        if (!id) {
            console.warn(`[useProfileData] No ID found in params.`)
            return;
        }

        console.log(`[useProfileData] Fetched profile data for ID: ${id}`);
        console.log(`[useProfileData] API URL: ${baseURL}/profiles/house-manager/${id}/`);

        setLoading(true);
        setError('');

        axios
            .get(`${baseURL}/profiles/house-manager/${id}/`)
            .then((response) => {
                setProfile(response.data);
                console.log(`[useProfileData] Fetched profile data:`, response.data);

                // const userId = response.data.user_id
            
                // console.log('Login user id:', userId)
                // console.log(response.data)
                // fetchReviews(userId)
                // fetchAlbum(id)
            })
            .catch((error) => {
                setError("Error fething profile");
                console.error(`[useProfileData] Error fetching profile data:`, error);
            })
            .finally(() => {
                setLoading(false);
                console.log(`[useProfileData] Fetch operation completed.`);
            })

    }, [id]);

    return { profile, loading, error };
}